module.exports = __webpack_public_path__ + "media/images/icons/outlined/skin-8a177cbddc58e38f1115645c6bbf6a5b.svg";